import React, { useEffect, useState } from 'react';
import { enGB } from 'date-fns/locale';
import { DatePicker, useDateInput } from 'react-nice-dates';
import cn from 'classnames';

import { ReactComponent as IconCalendar } from '../../public/images/icons/calendar.svg';

import 'react-nice-dates/build/style.css';
import './index.scss';

const DatePickerExample = ({onChange}) => {
  const [date, setDate] = useState();

  useEffect(() => {
    onChange && onChange(date);
  }, [date]);

  return (
    <div className={'calendar'}>
      <DatePicker date={date} onDateChange={setDate} format='MM/dd/yyyy' locale={enGB}
                  minimumDate={new Date(new Date().setDate((new Date()).getDate() + 1))}
      >
        {({ inputProps, focused }) => (
          <div className='calendar__field'>
            <IconCalendar className='calendar__icon' fill= {cn('#8B8B98', focused && '#45286B')}/>
            <input
              className={cn('calendar__input', focused ? ' -focused' : '')}
              {...inputProps}
              placeholder='Date'
              id='calendar'
            />
          </div>
        )}
      </DatePicker>
    </div>
  );
};
export default DatePickerExample;
